import Spinners from "components/Common/Spinner"
import { formatDate } from "helpers/date-format"
import React, { useState, useMemo, useEffect } from "react"
import { useSelector } from "react-redux"
import "../../newcomponents/index.css"
import {
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap"

const CustomerDetailsRightCard = ({
  currentActiveTab,
  scroollRef,
  isLoading,
  setLoading,
  distributions,
  filteredSurveys,
  handleDistributionClick,
  distributionModalOpen,
  toggleModal,
  activeDistribution,
  filteredVisits,
}) => {
  const mode = useSelector(state => state.Layout.layoutMode)

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 7 // ✅ Show only 6–7 entries per page (no scroll)

  // Determine which data to paginate based on active tab
  const dataToDisplay =
    currentActiveTab === "Visits" ? filteredVisits : filteredSurveys

  // Calculate pagination
  const totalPages = Math.ceil((dataToDisplay?.length || 0) / itemsPerPage)

  // Get current page data
  const currentData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return dataToDisplay?.slice(startIndex, endIndex) || []
  }, [currentPage, dataToDisplay, itemsPerPage])

  // Pagination handler
  const paginate = pageNumber => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber)
    }
  }

  // Reset to page 1 when tab changes
  useEffect(() => {
    setCurrentPage(1)
  }, [currentActiveTab])

  return (
    <div
      style={{
        borderRadius: "20px",
      }}
      className="w-100 user-chat mt-0 mt-sm-0 ms-lg-3"
    >
      <Card
        className="card"
        style={{
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 120px)",
        }}
      >
        {/* Card Header */}
        <div className="p-3 px-lg-4 border-bottom">
          <Row className="align-items-center">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-between"
            >
              <h4 className="mt-2 text-truncate flex-grow-1">
                {currentActiveTab}
              </h4>
            </Col>
          </Row>
        </div>

        {/* Table */}
        <div className="px-4 pt-3" style={{ flex: 1, overflow: "hidden" }}>
          {isLoading ? (
            <div className="py-4">
              <Spinners setLoading={setLoading} />
            </div>
          ) : currentActiveTab === "Visits" ? (
            <div className="table-responsive">
              <Table striped className="mb-0">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Day</th>
                    <th>Time</th>
                    <th>Service</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map(visit => {
                    const visitDate = new Date(visit.visitDate)
                    const formattedDay = visitDate.toLocaleString("en-US", {
                      weekday: "long",
                    })
                    const formattedTime = visitDate.toLocaleString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })

                    return (
                      <tr key={visit.id} style={{ cursor: "pointer" }}>
                        <td>{formatDate(visit.visitDate)}</td>
                        <td>{formattedDay}</td>
                        <td>{formattedTime}</td>
                        <td>{visit.service || "N/A"}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          ) : (
            // SURVEY DISTRIBUTIONS TAB
            <div>
              {distributions && distributions.length > 0 ? (
                <div className="table-responsive">
                  <Table striped className="mb-0">
                    <thead>
                      <tr>
                        <th>Survey Title</th>
                        <th>Sent At</th>
                        <th>Responded</th>
                        <th>Opened</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map(dist => (
                        <tr key={dist.survey.id}>
                          <td>{dist.survey.title}</td>
                          <td>{formatDate(dist.createdAt)}</td>
                          <td>{dist.Responded ? "Yes" : "No"}</td>
                          <td>{dist.Opened ? "Yes" : "No"}</td>
                          <td>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleDistributionClick(dist)}
                            >
                              View Details
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="text-center mt-4">
                  <h5>No Surveys Found</h5>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Pagination Footer */}
        {!isLoading && dataToDisplay && dataToDisplay.length > 0 && (
          <div className="p-3 border-top">
            <Pagination className="mb-0 justify-content-center">
              <PaginationItem disabled={currentPage === 1}>
                <PaginationLink
                  style={{
                    color: mode === "dark" ? "#fff" : "#000",
                    backgroundColor: "transparent",
                    borderColor: mode === "dark" ? "#444" : "#dee2e6",
                  }}
                  previous
                  onClick={() => paginate(currentPage - 1)}
                />
              </PaginationItem>

              {Array.from({ length: totalPages }).map((_, i) => (
                <PaginationItem active={i + 1 === currentPage} key={i}>
                  <PaginationLink
                    style={{
                      borderColor:
                        i + 1 === currentPage
                          ? "#2990DF"
                          : mode === "dark"
                            ? "#444"
                            : "#dee2e6",
                      boxShadow: "none",
                      backgroundColor:
                        i + 1 === currentPage ? "#2990DF" : "transparent",
                      color:
                        i + 1 === currentPage
                          ? "#fff"
                          : mode === "dark"
                            ? "#fff"
                            : "#000",
                    }}
                    onClick={() => paginate(i + 1)}
                  >
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              <PaginationItem disabled={currentPage === totalPages}>
                <PaginationLink
                  style={{
                    color: mode === "dark" ? "#fff" : "#000",
                    backgroundColor: "transparent",
                    borderColor: mode === "dark" ? "#444" : "#dee2e6",
                  }}
                  next
                  onClick={() => paginate(currentPage + 1)}
                />
              </PaginationItem>
            </Pagination>
          </div>
        )}

        {/* Survey Details Modal */}
        <Modal isOpen={distributionModalOpen} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>
            {activeDistribution?.survey?.title || "Survey Details"}
          </ModalHeader>
          <ModalBody>
            {/* Categories & Questions */}
            {activeDistribution?.survey?.SurveyCategories &&
            activeDistribution.survey.SurveyCategories.length > 0 ? (
              activeDistribution.survey.SurveyCategories.map(category => (
                <div key={category.id} className="category-section mb-4">
                  <h6 className="text-primary">{category.name}</h6>
                  {category.description && <p>{category.description}</p>}

                  {/* Display Questions & Responses */}
                  {category.SurveyQuestions &&
                  category.SurveyQuestions.length > 0 ? (
                    <Table bordered>
                      <thead>
                        <tr>
                          <th>Question</th>
                          <th>Response</th>
                        </tr>
                      </thead>
                      <tbody>
                        {category.SurveyQuestions.map(question => (
                          <tr key={question.id}>
                            <td>{question.questionText}</td>
                            <td>
                              {question.SurveyResponses &&
                              question.SurveyResponses.length > 0
                                ? question.SurveyResponses[0].responseValue
                                : "No response"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <p>No questions available</p>
                  )}
                </div>
              ))
            ) : (
              <p>No categories available</p>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </Card>
    </div>
  )
}

export default CustomerDetailsRightCard
